import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom'; // Not used in original logic, kept commented
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt, faEye, faIdBadge, faClock, faMoneyBillWave, faBriefcaseMedical, faChevronRight, faArrowRight // Added faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import patientImg from '../../assets/img/patients/patient.jpg';
import '../../assets/css/style.css';
import './Appointments.css';
 const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; 

const Appointments = () => {
    const [doctors, setDoctors] = useState([]);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/doctor`)
            .then(response => {
                setDoctors(response.data);
            })
            .catch(error => {
                console.error('There was an error fetching the doctor data!', error);
            });
    }, []);

    const getDoctorImageUrl = (imagePath) => {
        if (!imagePath) return patientImg;
        if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
            return imagePath;
        }
        return `${API_BASE_URL}/doctor/${imagePath}`;
    };
const formatTime12Hour = (time24) => {
  if (!time24) return 'N/A'; // Handle case where time is not available

  // Split the time string into hours and minutes
  const [hours, minutes] = time24.split(':');

  // Convert hours from string to number
  let hour = parseInt(hours, 10);

  // Determine AM or PM
  const ampm = hour >= 12 ? 'PM' : 'AM';

  // Convert hour to 12-hour format
  hour = hour % 12;
  // If hour is 0 (e.g., 12 AM), it should be 12
  hour = hour ? hour : 12;

  // Return the formatted time string
  return `${hour}:${minutes} ${ampm}`;
};
    return (
        <>
            <div className="appoints-page-container">
                <header className="appoints-main-header">
                    <Navbar />
                </header>

                <section className="appoints-hero-breadcrumb-section">
                    <div className="appoints-container">
                        <nav aria-label="breadcrumb" className="appoints-breadcrumb-nav">
                            <ol className="appoints-breadcrumb-list">
                                <li className="appoints-breadcrumb-item"><a href="/">Home</a></li>
                                <li className="appoints-breadcrumb-item appoints-breadcrumb-current" aria-current="page">Our Specialists</li>
                            </ol>
                        </nav>
                        <h1 className="appoints-page-main-title">Meet Our Esteemed Doctors</h1>
                        <p className="appoints-page-subtitle">
                            Discover dedicated professionals committed to your well-being.
                        </p>
                    </div>
                </section>

                <main className="appoints-content-area">
                    <div className="appoints-container">
                        <div className="appoints-doctors-listing-wrapper" id="appoints-listing-wrapper">
                            {doctors.length > 0 ? (
                                <div className="appoints-doctors-grid-container">
                                    {doctors.map(doctor => {
                                        
                                        // --- FIX: Logic to get correct timings is now INSIDE the map ---
                                        // We use optional chaining (?.) and nullish coalescing (??) for safety.
                                        const availableSlots = doctor.defaultAvailability?.filter(slot => slot.isAvailable) ?? [];

                                        return (
                                            <article className="appoints-doctor-profile-card" key={doctor.doctorId} id={`appoints-doctor-${doctor.doctorId}`}>
                                                <div className="appoints-profile-card-visual">
                                                    <a href={`/doctor-profile/${doctor.doctorId}`} className="appoints-profile-image-link">
                                                        <img
                                                            src={getDoctorImageUrl(doctor.image)}
                                                            alt={`${doctor.name}`}
                                                            className="appoints-profile-avatar"
                                                            onError={(e) => { e.target.onerror = null; e.target.src = patientImg; }}
                                                        />
                                                    </a>
                                                </div>
                                                <div className="appoints-profile-card-info">
                                                    <h2 className="appoints-profile-name">
                                                        <a href={`/doctor-profile/${doctor.doctorId}`}> {doctor.name}</a>
                                                    </h2>
                                                    <p className="appoints-profile-specialty">
                                                        <FontAwesomeIcon icon={faBriefcaseMedical} className="appoints-detail-icon" />
                                                        {doctor.speciality}
                                                    </p>
                                                    <div className="appoints-profile-meta-details">
                                                          <span className="appoints-meta-item" id={`appoints-doc-address-${doctor.doctorId}`}>
                                                          Location :
                                                            <FontAwesomeIcon icon={faMapMarkerAlt} className="appoints-detail-icon" style={{marginRight:"0px",marginLeft:"5px"}}  />
                                                            {doctor.address ? doctor.address.split(',')[0] : 'Location N/A'}
                                                        </span>
                                                         <span className="appoints-meta-item" id={`appoints-doc-price-${doctor.doctorId}`}>
                                                         Consultation Fees :
                                                            <FontAwesomeIcon icon={faMoneyBillWave} className="appoints-detail-icon" style={{marginRight:"0px",marginLeft:"5px"}}/>
                                                            ₹{doctor.price}
                                                        </span>
                                                  

                                                        {availableSlots.length > 0 ? (
                                                            availableSlots.map((slot, idx) => (
                                                                <span key={idx} className="timming">
                                                                    <FontAwesomeIcon icon={faClock} style={{ marginRight: "5px" }} />
                                                                    {formatTime12Hour(slot.startTime)} - {formatTime12Hour(slot.endTime)}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span className="appoints-meta-item appoints-timming-not-set">
                                                                <FontAwesomeIcon icon={faClock} className="appoints-detail-icon" />
                                                                Doctor Not Available
                                                            </span>
                                                        )}
                                                    </div>

                                                  
                                                    <div className="appoints-profile-card-action">
                                                        <a href={`/doctor-profile/${doctor.doctorId}`} className="appoints-btn appoints-btn-secondary-outline">
                                                            View Profile
                                                        </a>
                                                        <a href={`/patientlogin/${doctor.doctorId}`} className="appoints-btn appoints-btn-primary-solid">
                                                            Book Now
                                                            <FontAwesomeIcon icon={faArrowRight} className="appoints-btn-icon-right" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </article>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="appoints-no-doctors-found-message">
                                    <p>We are currently updating our list of specialists. Please check back soon.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
};

export default Appointments;